import axios from "axios";
import { ResponseAPIWithPagination } from "../../../common/types/API.types";
import { Client8000, Meter, meterInfolocalization, MeterPatch, JoulyMetersResponse, MeterPoleLink } from "../types/meter.types";

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL + "/api/v1";

export const getAllMeters = async (currentPage: number, pageSize: number, filter?: { querySearch?: string }) => {
    const params = "currentPage=" + currentPage + "&pageSize=" + pageSize;
    const filterParams = "&orderByQuery=-mtr_updated_at" + (filter?.querySearch ? "&query=" + filter.querySearch : "");

    return (await axios.get<ResponseAPIWithPagination<Meter>>(`${BACKEND_URL}/meters?${params}${filterParams}`)).data;
};

export const getMeterById = async (id: string) => {
    return (await axios.get<Meter>(`${BACKEND_URL}/meters/${id}`)).data;
};

export const createMeter = async (meter: MeterPatch) => {
    return (await axios.post<Meter>(`${BACKEND_URL}/meters`, meter)).data;
};

export const updateMeter = async (meterId: string, meter: MeterPatch) => {
    return (await axios.put<Meter>(`${BACKEND_URL}/meters/${meterId}`, meter)).data;
};

export const deleteMeter = async (meterId: string) => {
    return (await axios.delete<Meter>(`${BACKEND_URL}/meters/${meterId}`)).data;
};

export const getClient8000ByMeterId = async (meterId: string) => {
    return (await axios.get<Client8000>(`${BACKEND_URL}/meters/${meterId}/info/client`)).data;
};

export const getMeterInfoLocalizationByMeterId = async (meterId: string) => {
    return (await axios.get<meterInfolocalization>(`${BACKEND_URL}/meters/${meterId}/info/localization`)).data;
};

export const getJoulyMeters = async (
    currentPage: number = 1,
    pageSize: number = 10,
    orderBy?: string,
    where?: string,
    search?: string
) => {
    const params = new URLSearchParams({
        currentPage: currentPage.toString(),
        pageSize: pageSize.toString(),
    });
    
    if (orderBy) {
        params.append('orderBy', orderBy);
    }
    
    if (where) {
        params.append('where', where);
    }

    if (search) {
        params.append('query', search);
    }

    return (await axios.get<JoulyMetersResponse>(`${BACKEND_URL}/meters/jouly/meters?${params.toString()}`)).data;
};

export const getJoulyMeterCount = async (minigridName: string): Promise<number> => {
    const params = new URLSearchParams({ minigridName });
    const res = await axios.get<{ total_count: number }>(
        `${BACKEND_URL}/meters/jouly/count?${params.toString()}`,
    );
    return res.data.total_count;
};

export interface PaymentDetailAPI {
    paymentID: string;
    timePayment: string;
    transactionId: string;
    typePayment: string;
    boxId: string;
    money: number;
    currency: string;
    day: number;
    kwh: number;
    codeId: string;
    status: string;
    info: string;
}

// Liaisons reelles compteur->poteau (pl_link) du compte courant. Le compte est
// derive du token cote serveur, donc aucun parametre n'est requis.
export const getMeterPoleLinks = async (): Promise<MeterPoleLink[]> => {
    return (await axios.get<MeterPoleLink[]>(`${BACKEND_URL}/meters/jouly/pole-links`)).data;
}

export const getPaymentsByMeterId = async (meterId: string): Promise<PaymentDetailAPI[]> => {
    const response = await axios.get<PaymentDetailAPI[]>(`${BACKEND_URL}/meters/${meterId}/payments`);
    return response.data;
};

export const meterAPI = {
    getAllMeters,
    getMeterById,
    createMeter,
    updateMeter,
    deleteMeter,
    getClient8000ByMeterId,
    getMeterInfoLocalizationByMeterId,
    getJoulyMeters,
    getJoulyMeterCount,
    getPaymentsByMeterId,
    getMeterPoleLinks,
};

export default meterAPI;
